<template>
  <div>
    <Index />
    <News />
    <Books />
  </div>
</template>

<script>
import { Scrollbar } from "element-ui";
import Index from "@c/FDIndex";
import Footer from "@c/Footer";
import News from "@c/FDNews";
import Books from "@c/FDBooks";
import { post } from "@u/request";


export default {
  name: "",
  components: { Index, Footer, Scrollbar, News, Books },
  data() {
    return {
      logo: "",
      copyright: {},
    };
  },
  computed: {
    // 缓存页面name
    catche() {
      return this.$store.getters.includeArr;
    },
    key() {
      return this.$router.fullPath;
    },
  },
  methods: {
    async load() {
      const params = {
        cfgtype: 1,
        venueIds: this.$store.getters.venueId,
      };
      const { data } = await post("resource/cfgcommon/list", params);
      data.forEach((item) => {
        if (item.cfgkey === "SYS_AUTHINFO") {
          document.title = item.cfgvalue2;
        }
        if (
          item.cfgkey === "SYS_LOGO" ||
          item.cfgkey === "SYS_QRCODE" ||
          item.cfgkey === "SYS_HEADER_BG"
        ) {
          this.$set(this.copyright, item.cfgkey, item.cfgvalue);
        } else {
          this.$set(this.copyright, item.cfgkey, item.cfgvalue2);
        }
      });
    },
  },
  mounted() {
    // this.load();
  },
};
</script>

<style scoped lang="scss">

</style>
